import { format } from "date-fns";
import { capitalize } from "lodash";

import type { VanityUrlMetricsItem } from "~/types";



export function toCamelCaseFormatter(value: string) {
  return value
    .toLowerCase()
    .replace(" ", "-")
    .replace("--", "-")
    .replace(/[^\d A-Za-z-]/, "");
}
export const INPUT_ID = "vanity-url-input";

export function setInputElementValue(value: string) {
  const element = document.querySelector(`#${INPUT_ID}`) as HTMLInputElement;
  if (element) {
    element.value = value;
  }
}

export function getInputElementValue() {
  const element = document.querySelector(`#${INPUT_ID}`) as HTMLInputElement;
  if (element) {
    return element.value;
  }

  return null;
}

export function _handleInputChange(event: React.FormEvent<HTMLInputElement>) {
  const _formattedInput = toCamelCaseFormatter(event.currentTarget.value);
  event.currentTarget.value = _formattedInput;

  return _formattedInput;
}

/**
 * Metrics Modal
 */

export function getDateEpochByKey(key: string) {
  return getOrderByKey(key) === 3
    ? Number(getDateFromMonthKey(key))
    : Number(new Date(key));
}

export function getCategoryByKey(key: string) {
  if (key === "total") {
    return "total";
  }
  if (key.split(".").length === 1 && key !== "total") {
    return "year";
  }
  if (key.split(".").length === 2) {
    return "month";
  }
  if (key.split(".").length === 3) {
    return "day";
  }

  return "No Category";
}

export function getOrderByKey(key: string): 1 | 2 | 3 | 4 | 5 {
  if (key === "total") {
    return 1;
  }
  if (key.split("/").length === 1 && key !== "total") {
    return 2;
  }
  if (key.split("/").length === 2) {
    return 3;
  }
  if (key.split("/").length === 3) {
    return 4;
  }

  return 5;
}

export function orderByKeySorter(
  a: VanityUrlMetricsItem,
  b: VanityUrlMetricsItem,
) {
  const aSort = getOrderByKey(a.key);
  const bSort = getOrderByKey(b.key);

  return aSort === bSort
    ? getDateEpochByKey(a.key) - getDateEpochByKey(b.key)
    : aSort - bSort;
}

export function toSlashedDate(dottedDate: string) {
  return dottedDate.replaceAll(".", "/");
}

export function getDateFromMonthKey(key: string) {
  return new Date(`${key.split("/").reverse().join("/")}/1`);
}

export function getFormattedDateForMetric(record: VanityUrlMetricsItem) {
  switch (getOrderByKey(record.key)) {
    case 3: {
      return format(getDateFromMonthKey(record.key), "MMM, yyyy");
    }
    case 4: {
      return format(new Date(record.key), "MMM do, yyyy");
    }
    default: {
      return capitalize(record.key);
    }
  }
}
